var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fixed inset-0 z-50"},[_c('div',{staticClass:"absolute inset-0 bg-black opacity-50"}),_c('div',{staticClass:"absolute inset-0 flex items-center justify-center"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }